import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import * as Store from '../../store';

@Component
export default class Header extends Vue {
    // eslint-disable-next-line class-methods-use-this
    created() {}

    // eslint-disable-next-line class-methods-use-this
    mounted() {}

    get isLoggedIn(): boolean {
        return Store.readLoggedInState(this.$store);
    }

    toggleSidebar() {
        Store.commitSidebarOpen(this.$store, !Store.readSidebarOpen(this.$store));
    }

    doLogout() {
        localStorage.removeItem('hud');
        Store.commitLoggedInState(this.$store, false);
        Store.commitLoggedInUser(this.$store, {});
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/header/index.ts